export * from './top-marketing-image';
